import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
* Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-08-21
 * @brief SEI 주소 검색 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
// img, css etc
// utils
import * as CUTIL from "../../../utils/commUtils";
// components
import DaumPostcode from "react-daum-postcode";
import { langId } from "../../../recoil/langState";
import { useRecoilValue } from "recoil";
import { useTrans } from "../../../utils/langs/useTrans";
function EhpPostCode(props) {
    const t = useTrans();
    const langIds = useRecoilValue(langId);
    // 주소 검색 팝업 창 레이아웃
    const popBody = props.popBody;
    const isPopup = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("isPopup")
                ? popBody.props.isPopup
                : null
            : null
        : null;
    const setParentIsPopup = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("setIsPopup")
                ? popBody.props.setIsPopup
                : null
            : null
        : null;
    const setParentAddress = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("setAddress")
                ? popBody.props.setAddress
                : null
            : null
        : null;
    const notInPop = (!CUTIL.isnull(popBody))
        ? popBody.hasOwnProperty("props")
            ? popBody.props.hasOwnProperty("notInPop")
                ? popBody.props.notInPop
                : null
            : null
        : null;
    // 주소 검색 관련 기능
    const [address, setAddress] = useState("");
    const [addressInfo, setAddressInfo] = useState(null);
    const [detailAddress, setDetailAddress] = useState("");
    const [defaultQuery, setDefaultQuery] = useState("");
    useEffect(() => {
        setDefaultQuery("");
    });
    function onClickSaveAddress(e) {
        if (notInPop !== null) {
            CUTIL.jsclose_Popup("pop-postcode");
        }
        else {
            CUTIL.jsclose_InPopup("pop-postcode");
        }
        setDefaultQuery("");
        const sigunguCdInfo = addressInfo.sigunguCode;
        const bjdongCdInfo = addressInfo.bcode.slice(5, 10);
        const bunInfo = String(addressInfo.jibunAddress.split(" ").reverse()[0].split("-")[0]).padStart(4, "0");
        const autoBunInfo = (!addressInfo.autoJibunAddress) ? bunInfo : String(addressInfo.autoJibunAddress.split(" ").reverse()[0].split("-")[0]).padStart(4, "0");
        const jiInfo = (addressInfo.jibunAddress.split(" ").reverse()[0].split("-")[1]) ? String(addressInfo.jibunAddress.split(" ").reverse()[0].split("-")[1]).padStart(4, "0") : "0000";
        const autoJiInfo = (!addressInfo.autoJibunAddress) ? jiInfo : (addressInfo.autoJibunAddress.split(" ").reverse()[0].split("-")[1]) ? String(addressInfo.autoJibunAddress.split(" ").reverse()[0].split("-")[1]).padStart(4, "0") : "0000";
        const postalCodeInfo = addressInfo.zonecode;
        const bname = addressInfo.bname;
        const allAddress = {
            address: address,
            sigunguCd: sigunguCdInfo,
            bjdongCd: bjdongCdInfo,
            bun: autoBunInfo,
            ji: autoJiInfo,
            postalCode: postalCodeInfo,
            bname: bname
        };
        setParentAddress(allAddress);
        setParentIsPopup(false);
        setAddress("");
    }
    function onCompletePost(data) {
        let address = (data.jibunAddress) ? data.jibunAddress : data.autoJibunAddress;
        setAddress(address);
        setAddressInfo(data);
        /* // 지번, 도로명 분리
        if (data.userSelectedType == "J") {
          setAddress(data.address);
        } else {
          setAddress(data.roadAddress);
        } */
    }
    function Close(id) {
        setParentIsPopup(false);
        if (notInPop !== null) {
            CUTIL.jsclose_Popup(id);
        }
        else {
            CUTIL.jsclose_InPopup(id);
        }
    }
    function onClosePostCode(state) {
        if (state === 'FORCE_CLOSE') {
            //사용자가 브라우저 닫기 버튼을 통해 팝업창을 닫았을 경우, 실행될 코드를 작성하는 부분입니다.
        }
        else if (state === 'COMPLETE_CLOSE') {
            //사용자가 검색결과를 선택하여 팝업창이 닫혔을 경우, 실행될 코드를 작성하는 부분입니다.
            //oncomplete 콜백 함수가 실행 완료된 후에 실행됩니다.
        }
        setDefaultQuery("");
        setParentAddress(address);
        CUTIL.jsclose_InPopup("pop-postcode");
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-postcode", className: "popup-layer js-layer layer-out hidden popup-address" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.주소찾기") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-postcode") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("div", Object.assign({ className: "frame__address" }, { children: (isPopup) && _jsx(DaumPostcode, { autoClose: false, onComplete: onCompletePost, defaultQuery: defaultQuery }) })), _jsx("div", Object.assign({ className: "input__address" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.지번주소") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { placeholder: t("라벨.주소선택"), value: (address) ? address : "", readOnly: true }) }))] }) })) }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-postcode") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "js-close", disabled: (address) ? false : true, onClick: (e) => onClickSaveAddress(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))] })) }));
}
export default EhpPostCode;
